import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst = {
  ACTION: {
    getTeacherList: {
      api: 'T2040TeacherScheduleService.doBrowseAllTeacherByCenter',
      input: {
        center_no: 0,
        start_date: null
      }
    },
  }
}

const module = {
  state: {
    PageConst,

    teacherList: [], // C10301-2, C10301-3
  },

  getters: {},
  mutations: {},
  actions: {
    // C10301-2
    // C10301-3
    async getTeacherList ({ state }, payload ) {
      const res = await ApiUtils.postData({
        data: [{
          ...PageConst.ACTION.getTeacherList,
          input: payload
        }]
      }).catch(() => {
        this.commit('Notification/SET_NOTIFY_ERROR', {
          text: 'Error when getting teacher list'
        })
      })
      state.teacherList = res[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
